import DashboardElement from "~/models/dashboards/dashboardElement";
import { IDashboardElementListView } from "~/interfaces/dashboardInterfaces"
import DashboardElementListViewElementValidation from "~/models/navigableValidations/dashboardElementListViewElementValidation";

export default class ListViewElement extends DashboardElement {
    record_display_limit: number;
    title: string;
    list_view_id: string;
    list_view: IDashboardElementListView;

    constructor() {
        super();
        this.defineProperty("record_display_limit", 5);
        this.defineProperty('list_view_id', "");
    }

    except: string[] = ['list_view', 'dashboard_elements', 'createEmbeddedObject'];

    _validation: DashboardElementListViewElementValidation = new DashboardElementListViewElementValidation(this)
}